import React from 'react';
import {
  Breadcrumb, Layout, Typography, List, Avatar, Input, Card,
} from 'antd';
import { UserOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

const ChatsShow = ({ chat = {}, messages = [] }) => (
  <div className="container">
    <Breadcrumb
      style={{ margin: '16px 0' }}
      items={[
        { title: <a href="/chats">Чати</a> },
        { title: chat.name },
      ]}
    />
    <Layout style={{ padding: '24px 0', background: '#fff', borderRadius: 8 }}>
      <Layout.Content style={{ padding: '0 48px' }}>
        <Typography.Title level={3}>
          {chat.name}
        </Typography.Title>
        <Typography.Text type="secondary">
          <UserOutlined style={{ marginRight: 4 }} />
          {chat.userName}
        </Typography.Text>

        <Card
          style={{
            marginTop: 16,
            height: 500,
            display: 'flex',
            flexDirection: 'column',
          }}
          styles={{
            body: {
              flex: 1,
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
            },
          }}
        >
          <div style={{ flex: 1, overflowY: 'auto', marginBottom: 16 }}>
            <List
              dataSource={messages}
              locale={{ emptyText: 'Немає повідомлень' }}
              renderItem={(message) => (
                <List.Item style={{ border: 'none', padding: '8px 0' }}>
                  <List.Item.Meta
                    avatar={(
                      <Avatar
                        size="small"
                        style={{ backgroundColor: '#1677ff' }}
                        icon={<UserOutlined />}
                      />
                    )}
                    title={(
                      <span>
                        <Typography.Text strong>{message.userName}</Typography.Text>
                        <Typography.Text
                          type="secondary"
                          style={{ marginLeft: 8, fontSize: 12 }}
                        >
                          {message.createdAt}
                        </Typography.Text>
                      </span>
                    )}
                    description={(
                      <Typography.Text>{message.content}</Typography.Text>
                    )}
                  />
                </List.Item>
              )}
            />
          </div>

          <Input.TextArea
            rows={2}
            placeholder="Повідомлення..."
            disabled
            style={{ resize: 'none' }}
          />
        </Card>
      </Layout.Content>
    </Layout>
  </div>
);

ChatsShow.propTypes = {
  chat: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    userName: PropTypes.string,
  }),
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      content: PropTypes.string.isRequired,
      userName: PropTypes.string,
      createdAt: PropTypes.string,
    }),
  ),
};

export default ChatsShow;
